import { useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";

const TABS = ["All", "F&B & Cafes", "Health & Fitness", "Retail & Marts", "Cloud Kitchens"];

const TICKETS = [
  { label: "Any ticket", val: "All" },
  { label: "₹5,000", val: "5000" },
  { label: "₹10,000", val: "10000" },
];

const IRRS = [
  { label: "Any yield", val: "All" },
  { label: "Up to 22%", val: "le22" },
  { label: "22% & above", val: "gt22" },
];

const minValue = (m) => parseInt(m.replace(/[^0-9]/g, ""), 10);
const irrUpper = (s) => parseInt(s.split(/[–-]/)[1], 10);

const DEALS = [
  {
    title: "Artisanal Chai & QSR Cafe",
    city: "Indiranagar, Bengaluru",
    sector: "F&B & Cafes",
    scrip: "MCDHSR",
    img: "https://images.unsplash.com/photo-1766904413712-df0e9349e89f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjByZXRhaWwlMjBzdG9yZSUyMGNhZmUlMjBidXNpbmVzc3xlbnwwfHx8fDE3ODc3Mzk0NzF8MA&ixlib=rb-4.1.0&q=85",
    min: "₹5,000",
    target: "₹45,00,000",
    irr: "18–22%",
    funded: 72,
    members: 144,
  },
  {
    title: "Modern Tech-Enabled Gym",
    city: "Bandra, Mumbai",
    sector: "Health & Fitness",
    scrip: "FITBND",
    img: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=940&q=80",
    min: "₹10,000",
    target: "₹85,00,000",
    irr: "19–24%",
    funded: 54,
    members: 108,
  },
  {
    title: "Cloud Kitchen & Biryani Co.",
    city: "Gurugram, Delhi NCR",
    sector: "Cloud Kitchens",
    scrip: "CLDBRY",
    img: "https://images.unsplash.com/photo-1682778418768-16081e4470a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBmcmFuY2hpc2UlMjBmb29kJTIwc3RvcmUlMjByZXN0YXVyYW50fGVufDB8fHx8MTc4NzczOTQ3Nnww&ixlib=rb-4.1.0&q=85",
    min: "₹5,000",
    target: "₹35,00,000",
    irr: "20–25%",
    funded: 81,
    members: 162,
  },
  {
    title: "Quick Mart & Pharmacy Outlet",
    city: "Koramangala, Bengaluru",
    sector: "Retail & Marts",
    scrip: "MRTKOR",
    img: "https://images.pexels.com/photos/26861411/pexels-photo-26861411.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    min: "₹10,000",
    target: "₹60,00,000",
    irr: "16–20%",
    funded: 38,
    members: 76,
  },
];

export default function Opportunities() {
  const [tab, setTab] = useState("All");
  const [ticket, setTicket] = useState("All");
  const [irr, setIrr] = useState("All");

  const deals = DEALS.filter((d) => {
    if (tab !== "All" && d.sector !== tab) return false;
    if (ticket !== "All" && minValue(d.min) !== Number(ticket)) return false;
    if (irr === "le22" && irrUpper(d.irr) > 22) return false;
    if (irr === "gt22" && irrUpper(d.irr) < 22) return false;
    return true;
  });

  const resetFilters = () => {
    setTab("All");
    setTicket("All");
    setIrr("All");
  };

  return (
    <section id="opportunities" data-testid="curated-opportunities-grid" className="py-24">
      <div className="mx-auto max-w-6xl px-4">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-600">Curated opportunities</p>
          <h2 className="font-heading mt-4 text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            Franchise outlets opening for fractional participation
          </h2>
          <p className="mt-4 text-base text-slate-600">
            Every opportunity is pre-vetted by frantiger, follows the 60:40 capital rule, carries a
            unique 6-letter scrip ID, and pools a maximum of 200 investors. The min. ticket shown is
            the entry fraction size; waitlist members get first access when listings go live.
          </p>
        </div>

        <div className="mt-8 flex flex-wrap gap-3" data-testid="opportunity-filter-tabs">
          {TABS.map((t) => (
            <button
              key={t}
              data-testid={`filter-tab-${t.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              onClick={() => setTab(t)}
              className={`rounded-full px-5 py-2.5 text-sm font-bold transition-all ${
                tab === t
                  ? "clay-btn bg-orange-500 text-white"
                  : "neu-badge text-slate-600 hover:text-orange-600"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center" data-testid="opportunity-quick-filters">
          <div className="flex flex-wrap items-center gap-2" data-testid="filter-ticket-group">
            <span className="text-[11px] font-bold uppercase tracking-[0.12em] text-slate-400">Ticket</span>
            {TICKETS.map((t) => (
              <button
                key={t.val}
                data-testid={`filter-ticket-${t.val.toLowerCase()}`}
                onClick={() => setTicket(t.val)}
                className={`rounded-full px-4 py-2 text-xs font-bold transition-all ${
                  ticket === t.val
                    ? "bg-slate-900 text-white"
                    : "neu-badge text-slate-600 hover:text-orange-600"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
          <span className="hidden h-5 w-px bg-slate-200 sm:block" />
          <div className="flex flex-wrap items-center gap-2" data-testid="filter-irr-group">
            <span className="text-[11px] font-bold uppercase tracking-[0.12em] text-slate-400">Est. IRR</span>
            {IRRS.map((r) => (
              <button
                key={r.val}
                data-testid={`filter-irr-${r.val.toLowerCase()}`}
                onClick={() => setIrr(r.val)}
                className={`rounded-full px-4 py-2 text-xs font-bold transition-all ${
                  irr === r.val
                    ? "bg-slate-900 text-white"
                    : "neu-badge text-slate-600 hover:text-orange-600"
                }`}
              >
                {r.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-5 flex items-center gap-3 text-xs font-semibold text-slate-500" data-testid="filter-result-count">
          Showing <span className="font-black text-orange-600">{deals.length}</span> of {DEALS.length} opportunities
          {(tab !== "All" || ticket !== "All" || irr !== "All") && (
            <button
              onClick={resetFilters}
              data-testid="filter-clear-btn"
              className="rounded-full border border-slate-200 px-3 py-1 text-[11px] font-bold text-slate-600 transition-colors hover:border-orange-300 hover:text-orange-600"
            >
              Clear filters
            </button>
          )}
        </div>

        {deals.length === 0 ? (
          <div className="mt-10 rounded-[2rem] border border-dashed border-slate-300 bg-white/60 p-12 text-center" data-testid="opportunity-empty-state">
            <p className="font-heading text-lg font-extrabold text-slate-900">No opportunities match these filters</p>
            <p className="mt-2 text-sm text-slate-500">Try widening your ticket size or yield range.</p>
            <button
              onClick={resetFilters}
              data-testid="filter-empty-clear-btn"
              className="clay-btn mt-6 rounded-full bg-orange-500 px-6 py-3 text-sm font-bold text-white"
            >
              Clear all filters
            </button>
          </div>
        ) : (
        <div className="mt-10 grid gap-7 sm:grid-cols-2 lg:grid-cols-4">
          {deals.map((d) => (
            <article
              key={d.title}
              data-testid={`opportunity-card-${d.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="clay-card group flex flex-col overflow-hidden rounded-[1.75rem] transition-transform duration-300 hover:-translate-y-1.5"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={d.img}
                  alt={d.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="glass-surface absolute left-3 top-3 rounded-full px-3 py-1 text-[11px] font-bold text-slate-700">
                  {d.sector}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-bold leading-snug text-slate-900">{d.title}</h3>
                <p className="mt-1 flex items-center gap-1 text-xs font-semibold text-slate-500">
                  <MapPin className="h-3.5 w-3.5 text-orange-500" /> {d.city}
                </p>
                <p className="mt-1 text-[11px] font-bold uppercase tracking-wider text-orange-500">
                  Scrip: {d.scrip}
                </p>
                <div className="mt-4 grid grid-cols-3 gap-2 text-center">
                  {[
                    ["Min ticket", d.min],
                    ["Target", d.target],
                    ["Est. IRR", d.irr],
                  ].map(([k, v]) => (
                    <div key={k} className="rounded-xl bg-orange-50/80 px-1 py-2">
                      <p className="text-[13px] font-extrabold text-slate-900">{v}</p>
                      <p className="mt-0.5 text-[10px] font-semibold text-slate-500">{k}</p>
                    </div>
                  ))}
                </div>
                <div className="mt-4">
                  <div className="flex justify-between text-[11px] font-bold text-slate-500">
                    <span>Pool filling · {d.members}/200 members</span>
                    <span className="text-orange-600">{d.funded}%</span>
                  </div>
                  <div className="mt-1.5 h-2 overflow-hidden rounded-full bg-slate-100">
                    <div className="h-full rounded-full bg-gradient-to-r from-orange-400 to-orange-600" style={{ width: `${d.funded}%` }} />
                  </div>
                </div>
                <div className="mt-5 flex gap-2">
                  <Link
                    to={`/scrip/${d.scrip}`}
                    data-testid={`view-scrip-${d.scrip.toLowerCase()}`}
                    className="clay-btn inline-flex flex-1 items-center justify-center gap-1.5 rounded-full bg-orange-500 px-3 py-2.5 text-sm font-bold text-white"
                  >
                    View Scrip <ArrowRight className="h-4 w-4" />
                  </Link>
                  <a
                    href="#lead-form"
                    data-testid={`express-interest-${d.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="inline-flex flex-1 items-center justify-center rounded-full bg-slate-900 px-3 py-2.5 text-sm font-bold text-white transition-colors hover:bg-orange-600"
                  >
                    Express Interest
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
        )}
        <p className="mt-8 text-center text-xs text-slate-400">
          Cards above are illustrative. frantiger charges a 5% Annual Management Charge (AMC) to
          structure the fractional raise, plus a flat ₹100 platform fee on each secondary trade.
          Nothing here is an offer, solicitation or invitation to invest.
        </p>
      </div>
    </section>
  );
}
